var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, createContext, useContext } from 'react';
import { ChildrenBlockContext } from './ChildrenBlock.js';
import { BlockWrapperInstance } from './BlockWrapper.js';
export const ErrorUnknownBlockRenderComponent = (() => {
    throw new Error("Empty Rendering abnormal");
});
export const BlockContext = createContext(undefined);
export function BlockRender() {
    var _a, _b, _c;
    const blockContext = useContext(BlockContext);
    const childrenContext = useContext(ChildrenBlockContext);
    const props = (Object.assign(Object.assign({}, ((_a = blockContext === null || blockContext === void 0 ? void 0 : blockContext.attributes) !== null && _a !== void 0 ? _a : {})), ((_b = childrenContext === null || childrenContext === void 0 ? void 0 : childrenContext.childrenProps) !== null && _b !== void 0 ? _b : {})));
    const Block = ((_c = blockContext === null || blockContext === void 0 ? void 0 : blockContext.Block) !== null && _c !== void 0 ? _c : ErrorUnknownBlockRenderComponent);
    if (!blockContext) {
        console.error('You tried to render a Smartfire Block without using BlockViewer or BlockEditor, we are missing a context here.');
        throw new Error('No block context available to render');
    }
    return React.createElement(BlockWrapperInstance, null,
        React.createElement(Block, Object.assign({}, props)));
}
export function BlockViewer({ block: Block, childrenBlockRenderer: ChildrenBlockRenderer = undefined, children, }) {
    var _a;
    let viewer = function Viewer(_a) {
        var attributes = __rest(_a, []);
        const blockId = useMemo(() => `View-${rawViewId++}`, []);
        return (React.createElement(BlockContext.Provider, { value: {
                id: blockId,
                Block,
                attributes,
                childrenBlockRenderer: ChildrenBlockRenderer,
                children,
            } },
            React.createElement(BlockRender, null)));
    };
    Object.defineProperty(viewer, 'name', { value: 'BlockViewer-' + ((_a = Block === null || Block === void 0 ? void 0 : Block.name) !== null && _a !== void 0 ? _a : 'Raw') });
    return viewer;
}
let rawViewId = 0;
export const RawViewer = ({ children, childrenBlockRenderer, }) => {
    const blockId = useMemo(() => `Raw-${rawViewId++}`, []);
    return (React.createElement(BlockContext.Provider, { value: {
            id: blockId,
            Block: React.Fragment,
            attributes: {},
            childrenBlockRenderer,
        } }, children));
};

//# sourceMappingURL=BlockViewer.js.map
